import { createAction } from '@techstyle/redux-core';

export const trackPromoClicked = createAction('TRACK_PROMO_CLICKED');
export const trackPromoViewed = createAction('TRACK_PROMO_VIEWED');
